import { render, staticRenderFns } from "./SlideInPanel.vue?vue&type=template&id=1b21ee59&scoped=true&"
import script from "./SlideInPanel.vue?vue&type=script&lang=js&"
export * from "./SlideInPanel.vue?vue&type=script&lang=js&"
import style0 from "./SlideInPanel.vue?vue&type=style&index=0&id=1b21ee59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b21ee59",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
